import React from "react";

function BoldIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="currentColor"
            className={className}
        >
            <rect width="30" height="30" fill="none" />
            <path
                d="M19.232 16.842C19.232 17.8033 18.9287 18.5033 18.322 18.942C17.7153 19.3807 16.7633 19.6 15.466 19.6H11V9.8H15.438C17.6313 9.8 18.728 10.6867 18.728 12.46C18.728 12.852 18.6533 13.1787 18.504 13.44C18.3547 13.692 18.1913 13.8927 18.014 14.042C17.7993 14.21 17.5613 14.3407 17.3 14.434V14.504C17.6547 14.5787 17.9767 14.7093 18.266 14.896C18.3873 14.98 18.504 15.078 18.616 15.19C18.728 15.302 18.8307 15.4373 18.924 15.596C19.0173 15.7547 19.092 15.9367 19.148 16.142C19.204 16.3473 19.232 16.5807 19.232 16.842ZM17.412 16.744C17.412 16.2493 17.2533 15.89 16.936 15.666C16.628 15.4327 16.152 15.316 15.508 15.316H12.736V18.172H15.508C16.1707 18.172 16.6513 18.0553 16.95 17.822C17.258 17.5793 17.412 17.22 17.412 16.744ZM16.908 12.586C16.908 12.11 16.7633 11.7647 16.474 11.55C16.194 11.3353 15.7833 11.228 15.242 11.228H12.736V13.944H15.242C15.7647 13.944 16.1707 13.8413 16.46 13.636C16.7587 13.4307 16.908 13.0807 16.908 12.586Z"
            />
        </svg>
    );
}

export default BoldIcon;
